var render = function render(){
  var _vm$projectList, _vm$projectList2, _vm$projectList3, _vm$projectList4, _vm$projectList5, _vm$projectList6, _vm$projectList7, _vm$projectList8, _vm$projectList9, _vm$projectList10, _vm$projectList11, _vm$projectList12, _vm$projectList13, _vm$projectList14, _vm$projectList15, _vm$customerList, _vm$customerList2, _vm$customerList3, _vm$customerList4, _vm$customerList4$cus, _vm$customerList5, _vm$customerList6, _vm$customerList7, _vm$customerList8, _vm$customerList9, _vm$customerList10, _vm$customerList11, _vm$customerList12, _vm$customerList13, _vm$customerList13$cu;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "mb-5 d-flex justify-content-end",
    staticStyle: {
      "gap": "5px"
    }
  }, [_vm.localIsDetail && _vm.editId ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.toggleEdit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o ml-2 text-white"
  }), _vm._v(" Update Data ")]) : _vm._e(), !_vm.localIsDetail && _vm.editId ? [_c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.onSaveSpalProcess
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o ml-2 text-white"
  }), _vm._v(" Save Data ")]), _c('b-button', {
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.toggleEdit
    }
  }, [_vm._v(" Cancel Update ")])] : _vm._e()], 2), _vm._m(0), _c('b-row', [_c('b-col', {
    staticClass: "mb-2 d-flex justify-content-between align-items-center",
    attrs: {
      "md": "12"
    }
  }, [_c('div'), !_vm.localIsDetail ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.addSpalProcessRow
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-1"
  }), _vm._v(" Add Spal Process Row ")]) : _vm._e()], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "bordered": "",
      "items": _vm.tableItems,
      "fields": _vm.tableFields,
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(title)",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [!_vm.localIsDetail ? [_c('b-form-input', {
          attrs: {
            "required": "",
            "placeholder": "Type SPAL title"
          },
          model: {
            value: item.title,
            callback: function callback($$v) {
              _vm.$set(item, "title", $$v);
            },
            expression: "item.title"
          }
        })] : [_c('span', {
          staticClass: "font-semibold"
        }, [_vm._v(_vm._s(item.title || '-'))])]];
      }
    }, {
      key: "cell(notes)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [!_vm.localIsDetail ? [_c('b-form-textarea', {
          attrs: {
            "placeholder": "Notes"
          },
          model: {
            value: item.notes,
            callback: function callback($$v) {
              _vm.$set(item, "notes", $$v);
            },
            expression: "item.notes"
          }
        })] : [_c('span', [_vm._v(_vm._s(item.notes || '-'))])]];
      }
    }, {
      key: "cell(attachment)",
      fn: function fn(_ref3) {
        var _item$attachment, _item$attachment$, _item$attachment$$fil;
        var item = _ref3.item;
        return [!_vm.localIsDetail ? [_c('b-form-file', {
          attrs: {
            "required": _vm.required
          },
          model: {
            value: item.file,
            callback: function callback($$v) {
              _vm.$set(item, "file", $$v);
            },
            expression: "item.file"
          }
        })] : [item.attachment && item.attachment.length > 0 ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "secondary",
            "href": "".concat(_vm.apiUrl, "/download/").concat(item === null || item === void 0 ? void 0 : (_item$attachment = item.attachment) === null || _item$attachment === void 0 ? void 0 : (_item$attachment$ = _item$attachment[0]) === null || _item$attachment$ === void 0 ? void 0 : (_item$attachment$$fil = _item$attachment$.file_url) === null || _item$attachment$$fil === void 0 ? void 0 : _item$attachment$$fil.replace('upload/', '')),
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "ri-download-line mr-1"
        }), _vm._v(" Download ")]) : _c('span', [_vm._v("-")])]];
      }
    }, {
      key: "cell(fix)",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [!_vm.localIsDetail ? [_c('b-form-checkbox', {
          attrs: {
            "switch": ""
          },
          model: {
            value: item.is_fix_spal,
            callback: function callback($$v) {
              _vm.$set(item, "is_fix_spal", $$v);
            },
            expression: "item.is_fix_spal"
          }
        }, [_vm._v(" " + _vm._s(item.is_fix_spal ? 'Yes' : 'No') + " ")])] : [_c('span', {
          staticClass: "font-semibold"
        }, [_vm._v(" " + _vm._s(item.is_fix_spal ? 'Yes' : 'No') + " ")])]];
      }
    }, {
      key: "cell(comment)",
      fn: function fn(_ref5) {
        var index = _ref5.index;
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              return _vm.openCommentModal(index);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-comments mr-1"
        }), _vm._v(" Comment ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(_ref6) {
        var index = _ref6.index;
        return [!_vm.localIsDetail ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.removeSpalProcessRow(index);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })]) : _vm._e()];
      }
    }])
  })], 1), _c('b-modal', {
    attrs: {
      "id": "spal-comment-modal",
      "title": 'Comments',
      "hide-footer": ""
    }
  }, [_c('b-table', {
    attrs: {
      "small": "",
      "bordered": "",
      "items": _vm.commentItems,
      "fields": _vm.commentFields,
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(comment)",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c('span', [_vm._v(_vm._s(item.comment || '-'))])];
      }
    }, {
      key: "cell(name)",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c('span', [_vm._v(_vm._s(item.user_name || '-'))])];
      }
    }, {
      key: "cell(date)",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_c('span', [_vm._v(" " + _vm._s(item.createdAt ? _vm.moment(item.createdAt).format('DD/MM/YYYY') : '-') + " ")])];
      }
    }])
  })], 1), _c('b-col', {
    attrs: {
      "md": "12 my-3"
    }
  }, [_c('div', {
    staticClass: "d-flex w-100"
  }, [_c('button', {
    staticClass: "spal-tab",
    class: {
      active: _vm.activeTab === 'project_info'
    },
    staticStyle: {
      "border-top-left-radius": "8px",
      "border-bottom-left-radius": "8px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.activeTab = 'project_info';
      }
    }
  }, [_vm._v(" PROJECT INFORMATION ")]), _c('button', {
    staticClass: "spal-tab",
    class: {
      active: _vm.activeTab === 'customer'
    },
    staticStyle: {
      "border-top-right-radius": "8px",
      "border-bottom-right-radius": "8px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.activeTab = 'customer';
      }
    }
  }, [_vm._v(" CUSTOMER INFORMATION ")])])]), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-row', [_vm.activeTab == 'project_info' ? [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Project")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$projectList = _vm.projectList) === null || _vm$projectList === void 0 ? void 0 : _vm$projectList.projectName) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Company Name")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$projectList2 = _vm.projectList) === null || _vm$projectList2 === void 0 ? void 0 : _vm$projectList2.companyName) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Fleet Ownership")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$projectList3 = _vm.projectList) === null || _vm$projectList3 === void 0 ? void 0 : _vm$projectList3.fleetOwnership) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Fleet Type")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$projectList4 = _vm.projectList) === null || _vm$projectList4 === void 0 ? void 0 : _vm$projectList4.fleetTypes) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Period")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$projectList5 = _vm.projectList) === null || _vm$projectList5 === void 0 ? void 0 : _vm$projectList5.period) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Shipment Plan Number")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$projectList6 = _vm.projectList) === null || _vm$projectList6 === void 0 ? void 0 : _vm$projectList6.shipmentPlanNumber) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Contract Type")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$projectList7 = _vm.projectList) === null || _vm$projectList7 === void 0 ? void 0 : _vm$projectList7.contractType) || '-'))])])])])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Term")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$projectList8 = _vm.projectList) === null || _vm$projectList8 === void 0 ? void 0 : _vm$projectList8.term) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Port of Loading")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$projectList9 = _vm.projectList) === null || _vm$projectList9 === void 0 ? void 0 : _vm$projectList9.pol) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Port of Discharging")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$projectList10 = _vm.projectList) === null || _vm$projectList10 === void 0 ? void 0 : _vm$projectList10.pod) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Distance")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$projectList11 = _vm.projectList) === null || _vm$projectList11 === void 0 ? void 0 : _vm$projectList11.distance) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Laycan")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$projectList12 = _vm.projectList) === null || _vm$projectList12 === void 0 ? void 0 : _vm$projectList12.laycan) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Cargo Type")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$projectList13 = _vm.projectList) === null || _vm$projectList13 === void 0 ? void 0 : _vm$projectList13.cargoType) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Total Plan QTY")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$projectList14 = _vm.projectList) === null || _vm$projectList14 === void 0 ? void 0 : _vm$projectList14.totalPlanQty) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Remarks")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$projectList15 = _vm.projectList) === null || _vm$projectList15 === void 0 ? void 0 : _vm$projectList15.remarks) || '-'))])])])])])] : _vm.activeTab == 'customer' ? [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Company Name")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$customerList = _vm.customerList) === null || _vm$customerList === void 0 ? void 0 : _vm$customerList.companyName) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Website")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$customerList2 = _vm.customerList) === null || _vm$customerList2 === void 0 ? void 0 : _vm$customerList2.website) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Email")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$customerList3 = _vm.customerList) === null || _vm$customerList3 === void 0 ? void 0 : _vm$customerList3.email) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Country")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$customerList4 = _vm.customerList) === null || _vm$customerList4 === void 0 ? void 0 : (_vm$customerList4$cus = _vm$customerList4.customerActive) === null || _vm$customerList4$cus === void 0 ? void 0 : _vm$customerList4$cus.country_id) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Province")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$customerList5 = _vm.customerList) === null || _vm$customerList5 === void 0 ? void 0 : _vm$customerList5.province) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("City")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$customerList6 = _vm.customerList) === null || _vm$customerList6 === void 0 ? void 0 : _vm$customerList6.city) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Address")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$customerList7 = _vm.customerList) === null || _vm$customerList7 === void 0 ? void 0 : _vm$customerList7.address) || '-'))])])])])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("Nomor Pokok Wajib Pajak (NPWP)")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$customerList8 = _vm.customerList) === null || _vm$customerList8 === void 0 ? void 0 : _vm$customerList8.npwp) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("NIB Number")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$customerList9 = _vm.customerList) === null || _vm$customerList9 === void 0 ? void 0 : _vm$customerList9.nib) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("PIC Name")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$customerList10 = _vm.customerList) === null || _vm$customerList10 === void 0 ? void 0 : _vm$customerList10.picName) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("PIC Job Title")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$customerList11 = _vm.customerList) === null || _vm$customerList11 === void 0 ? void 0 : _vm$customerList11.job_title) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("PIC Mobile Phone")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$customerList12 = _vm.customerList) === null || _vm$customerList12 === void 0 ? void 0 : _vm$customerList12.mobile1) || '-'))])])]), _c('div', {
    staticClass: "mb-3 d-flex"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v("PIC Email")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(": "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(((_vm$customerList13 = _vm.customerList) === null || _vm$customerList13 === void 0 ? void 0 : (_vm$customerList13$cu = _vm$customerList13.customerActive) === null || _vm$customerList13$cu === void 0 ? void 0 : _vm$customerList13$cu.email) || '-'))])])])])])] : _vm._e()], 2)], 1)], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('h5', [_vm._v("SPAL / CONTRACT")])]);

}]

export { render, staticRenderFns }